module.exports = __webpack_public_path__ + "e3129885f220235bc909047065bebfb8.svg";